import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const usePerfilUsuario = () => {
  const { Token } = useUserSuperEmpresa();

  const getPerfilUsuario = async () => {
    try {
      const { data } = await api.get("/user/profile", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener el perfil del usuario";
    }
  };

  const updatePerfilUsuario = async (params = {}) => {
    try {
      const { data } = await api.put("/user/profile", params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al actualizar el perfil";
    }
  };

  const updatePassword = async (params = {}) => {
    try {
      const { data } = await api.put("/user/password", params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al actualizar la contraseña";
    }
  };

  return { getPerfilUsuario, updatePerfilUsuario, updatePassword };
};


/* funciones */

export const useGetUser = () => {
  const { getPerfilUsuario } = usePerfilUsuario();
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const data = await getPerfilUsuario();
        setPerfil(data);
      } catch (err) {
        setError(err || "Error al obtener el perfil");
      } finally {
        setLoading(false);
      }
    };

    fetchPerfil();
  }, []);

  return { perfil, loading, error };
};


export const useUsuariosSistema = () => {
  const { Token } = useUserSuperEmpresa();
   const getRol = async () => {
    try {
      const { data } = await api.get("/roles", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener los usuarios";
    }
  };
  // Obtener todos los usuarios
  const getUsuarios = async () => {
    try {
      const { data } = await api.get("/todos-users", {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener los usuarios";
    }
  };

  // Crear nuevo usuario
  const crearUsuario = async (params = {}) => {
    try {
      const { data } = await api.post("/users/crear", params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear el usuario";
    }
  };

  // Editar usuario existente
  const editarUsuario = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/users/${id}`, params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };

    const editarUsuariopassword = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/password/${id}`, params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };




  // Cambiar estado (activo/inactivo)
  const cambiarEstadoUsuario = async (id) => {
    try {
      const { data } = await api.patch(`/users/${id}/status`, {}, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al cambiar el estado del usuario";
    }
  };

  // Eliminar usuario
  const eliminarUsuario = async (id) => {
    try {
      const { data } = await api.delete(`/users/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };

  return {
     getRol,
    getUsuarios,
    crearUsuario,
    editarUsuario,
    cambiarEstadoUsuario,
    eliminarUsuario,
    editarUsuariopassword
  };
};


export const useGetUsers = () => {
  const { getUsuarios } = useUsuariosSistema();
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPerfil = async () => {
      try {
        const data = await getUsuarios();
        setPerfil(data);
      } catch (err) {
        setError(err || "Error al obtener el perfil");
      } finally {
        setLoading(false);
      }
    };

    fetchPerfil();
  }, []);

  return { perfil, loading, error };
};


export const useGetRol = () => {
  const { getRol } = useUsuariosSistema();
  const [Rol, setRol] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRol = async () => {
      try {
        const data = await getRol();
        setRol(data);
        
      } catch (err) {
        setError(err || "Error al obtener el Rol");
      } finally {
        setLoading(false);
      }
    };

    fetchRol();
  }, []);

  return { Rol, loading, error };
};
